// Written in this round about way for babel-transform-imports
import Prompt from 'react-router/es/Prompt';

export default Prompt;


//////////////////
// WEBPACK FOOTER
// c:/jenkins/workspace/plesk-17.8/~/react-router-dom/es/Prompt.js
// module id = 46
// module chunks = 1 2 3 4 5